import { render, staticRenderFns } from "./index.vue?vue&type=template&id=38748b17&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38748b17')) {
      api.createRecord('38748b17', component.options)
    } else {
      api.reload('38748b17', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=38748b17&", function () {
      api.rerender('38748b17', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/svcManage/index.vue"
export default component.exports